<template>
  <div class="container general-data" v-if="assetData">
    <div class="outer-wrapper flex-column align-items-start main-item">
      <div class="inner-wrapper">
        <div class="brand d-flex align-items-center content-wrapper">
          <img :src="getSymbolImageSrc(assetData.name)" class="icon-symbol" />
          <div
            class="text d-flex flex-column justify-content-around asset-wrapper w-100"
          >
            <div class="name-and-diff">
              <h1 class="asset-name">{{ assetData.name }}</h1>
              <span
                :class="rawSocketData.d1_num > 0 ? 'green_color' : 'red_color'"
                class="diff"
                v-if="rawSocketData"
                >{{ rawSocketData.d1_num }}% ({{
                  rawSocketData.d1_num_main
                }})</span
              >
            </div>
            <h2 class="asset-desc">{{ assetData.Description }}</h2>
          </div>
        </div>
        <div class="d-flex trade-btns">
          <button class="btn ripple-button" @click.prevent="clickOnAction">
            <div class="text">{{ t("Assets_Sell") }}</div>
            <div class="price" :class="visualPrice(price, 'cb')">
              {{ visualPrice(price, "b", "d") }}
            </div>
          </button>
          <button class="btn ripple-button" @click.prevent="clickOnAction">
            <div class="text">{{ t("Assets_Buy") }}</div>
            <div class="price" :class="visualPrice(price, 'ca')">
              {{ visualPrice(price, "a", "d") }}
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { visualPrice } from "@/utils/symbolsSocket";
import { mapGetters, mapState } from "vuex";

export default {
  name: "topSection",
  props: ["symbol"],

  computed: {
    ...mapState(['symbolsData']),
    ...mapState("symbolsSocket", ["quotes", "initialSocketData"]),
    ...mapGetters(["chartInstrumentDeepLink", "getSymbolImageSrc", "t"]),
    price: function() {
      return this.quotes[this.symbol];
    },
    rawSocketData: function() {
      return this.initialSocketData[this.symbol];
    },
    assetData: function() {
      return this.symbolsData[this.symbol];
    },
  },
  methods: {
    visualPrice: visualPrice,
    clickOnAction() {
      const that = this;
      setTimeout(function() {
        //to allow ripple effect to complete //TODO: fix css instead of js!
        window.location.href = that.chartInstrumentDeepLink(
          that.assetData.name
        );
      }, 400);
    }
  }
};
</script>

<style lang="scss" scoped>
$break1: 768px;
.outer-wrapper {
  margin: 38px auto 60px;
  @media only screen and (max-width: #{$break1}) {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .inner-wrapper {
    width: 100%;
    display: flex;
    @media only screen and (min-width: #{$break1}) {
      justify-content: space-between;
    }
    @media only screen and (max-width: #{$break1}) {
      flex-direction: column;
    }
    .brand {
      @media only screen and (max-width: #{$break1}) {
        margin-bottom: 24px;
      }
    }
  }
}
.general-data {
  .content-wrapper {
    .icon-symbol {
      width: 64px;
      @media only screen and (max-width: #{$break1}) {
        width: 36px;
      }
    }
    .asset-wrapper {
      margin-left: 26px;
      @media only screen and (max-width: #{$break1}) {
        margin-left: 12px;
      }
      .name-and-diff {
        @media only screen and (max-width: #{$break1}) {
          justify-content: space-between;
        }
        display: flex;
        .asset-name {
          font-size: 2rem;
          font-weight: bold;
          @media only screen and (max-width: #{$break1}) {
            font-size: 1.5rem;
          }
        }
        .diff {
          font-size: 20px;
          align-self: flex-end;
          margin-left: 10px;
          @media only screen and (max-width: #{$break1}) {
            font-size: 0.875rem;
          }
        }
      }
      .asset-desc {
        font-size: 1rem;
        color: #9e9e9e;
        font-weight: 400;
        margin:0;
        line-height: 1.5;
        @media only screen and (max-width: #{$break1}) {
          font-size: 0.875rem;

        }
      }
    }
  }
  .trade-btns {
    align-items: center;
    @media only screen and (max-width: #{$break1}) {
      justify-content: center;
    }
    @media only screen and (max-width: 450px) {
      justify-content: space-between;
    }
    .btn {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-weight: 500;
      min-width: 150px;
      border: 1px solid #7a7c7c;
      background-position: center;
      transition: background 0.8s;
      height: 40px;
      min-height: unset;

      .text {
        font-size: 1rem;
        font-weight: 500;
        color: #424242;
        margin-right: 0.5rem;
      }
      &:focus {
        box-shadow: none;
        border: 1px solid #424242;
        border-radius: 0.25rem;
      }
      &:hover {
        background-color: #1c79be;
        border: none;
        div {
          color: #ffffff;
        }
      }
      &:first-of-type {
        margin-right: 1rem;
      }
    }
  }
}
.outer-wrapper {
  .btn-outline-secondary:hover {
    background: inherit;
  }
}

.ar {
  .outer-wrapper {
    .brand {
      .asset-wrapper {
        margin: 0 26px 0 0;
      }
    }
    .trade-btns .btn {
      .text {
        margin-right: inherit;
        margin-left: 0.5rem;
      }
      &:first-of-type {
        margin: 0 0 0 1rem;
      }
    }
    .name-and-diff {
      .diff {
        align-self: flex-end;
        margin-right: 10px;
        margin-left: inherit;
      }
    }
  }
}

@media only screen and (max-width: 400px) {
  .es,
  .de {
    .outer-wrapper {
      .trade-btns .btn {
        .text {
          font-size: 0.875rem;
          margin-right: 4px;
        }
      }
    }
  }
}

@media only screen and (max-width: 380px) {
  .de {
    .outer-wrapper {
      .trade-btns .btn {
        .text {
          font-size: 0.75rem;
        }
      }
    }
  }
}
</style>
